module.exports = __webpack_public_path__ + "static/media/snowplow.ab6a4da7.svg";